export default __webpack_public_path__ + "static/media/example-pix.f2bc1d3f.svg";